import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/* Admin-editable prices for the Capital Readiness report unlock (p1 = Report,
   p2 = Report + advisory), per currency. Firestore doc `reportPricing/current`.
   Read by CapitalAssessment + CapitalReadinessAssessment via useReportPricing(). */

export type ReportPricing = { AED: { p1: string; p2: string }; USD: { p1: string; p2: string } };
export const DEFAULT_REPORT_PRICING: ReportPricing = { AED: { p1: '199', p2: '365' }, USD: { p1: '54', p2: '99' } };

const s = (v: any, d: string) => (v === undefined || v === null || v === '' ? d : String(v));

export function useReportPricing(): ReportPricing {
  const [p, setP] = useState<ReportPricing>(DEFAULT_REPORT_PRICING);
  useEffect(() => {
    const ref = doc(db, 'reportPricing', 'current');
    return onSnapshot(ref, snap => {
      if (!snap.exists()) return;
      const d = snap.data() as any;
      setP({
        AED: { p1: s(d?.AED?.p1, DEFAULT_REPORT_PRICING.AED.p1), p2: s(d?.AED?.p2, DEFAULT_REPORT_PRICING.AED.p2) },
        USD: { p1: s(d?.USD?.p1, DEFAULT_REPORT_PRICING.USD.p1), p2: s(d?.USD?.p2, DEFAULT_REPORT_PRICING.USD.p2) },
      });
    }, () => { /* keep defaults on error */ });
  }, []);
  return p;
}
